import React, { useEffect, useState } from 'react'
import './busmob.css';
import { 
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Box,
  Container,
  Typography,
  Button,
  Menu,
  MenuItem
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityBusMenu from '../dropdowns/dropBusCity';



const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


const saerchBtnStyle = {
  fontSize: '14px',
  borderRadius: '10px',
  width: '100px',
}

export default function BusesMobile() {
  const [value, setValue] = useState('round');
  const [start, setStart] = useState("Delhi, Delhi");
  const [dest, setDest] = useState("Noida, Uttar Pradesh");
  const [selectCity1, setSelectCity1] = useState(false);
  const [selectCity2, setSelectCity2] = useState(false);
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const [date,setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  const {user} = useUserAuth();
  const navigate = useNavigate()
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date])
  function CityCrad(props){
    const handleCityShow = ()=> {
      if(props.initial==='From'){
        setSelectCity1(true);
      }else if(props.initial==='To'){
        setSelectCity2(true);
      }
    }
    return <div className='bus-mobile' onMouseOver={handleCityShow}>
      <Typography variant='body2' fontSize='14px' paddingBottom='20px' onMouseOver={handleCityShow}>{props.initial}</Typography>
      <Typography variant='h1' fontSize='30px' fontWeight='bolder' onMouseOver={handleCityShow}>{props.cityName}</Typography>
      <Typography variant='body2' fontSize='20px' fontWeight='bold' onMouseOver={handleCityShow}>{props.airport}</Typography>
    </div>
  }
  function DateCard(props){
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleDates = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = ()=>{
    setAnchorEl(null);
  }
  const handleDateSetting = (e)=>{
    e.persist();
    if(props.showDate){
      setDate(e.target.value);
    }else{
      return;
    }
    
  }
  useEffect(()=>{
    setAnchorEl(null);
  }, [date])
    return <div className='bus-mobile'>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleDates}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.option}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateSetting}/></MenuItem>
      </Menu>
      {props.showDate && 
        <div>
        {date ? <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{userDate.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
        </> : 
        <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </>
        }
      </div>
      }
      {!props.showDate && <Typography variant='body2' fontWeight='bold' textAlign='left' sx={{padding:'10px'}}>Tap to add a return date for bigger discount</Typography>}
    </div>
  }
  const handleTickets = ()=> {
    if(user){
      navigate('/tickets/bus');
    }else{
      navigate('/login');
    }
  }
  return (
    <div>
      <div className='busMobile'>
      <Container>
        <FormControl component="fieldset">
          <FormLabel component="legend"> </FormLabel>
          <RadioGroup name="tour" value={value} onChange={handleChange}>
          <Box
          display='flex'
          sx={{paddingTop: '40px'}}
          >
            <FormControlLabel value="one" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Book 2X2 Bus" />
            <FormControlLabel value="round" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Check Availability" />
            <FormControlLabel value="multi" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="AC Bus" />
          </Box>
          </RadioGroup>
        </FormControl>
      </Container>
      <div>
        <Box 
        display='flex'
        sx={{flexDirection:'column'}}
        >
          <Container><CityCrad initial={'From'} cityName={start} airport={"India"} /></Container>
          <Container>{selectCity1 && <div className='busCity1'><CityBusMenu setterFunc={setStart} removeMenu={setSelectCity1} /></div>}</Container>
          <Container><CityCrad initial={'To'} cityName={dest} airport={"India"} /></Container>
          <Container> {selectCity2 && <div className='busCity2'><CityBusMenu setterFunc={setDest} removeMenu={setSelectCity2} /></div>}</Container>
          <Container><DateCard option={'Departure'} showDate={true}/></Container>
        </Box>
      </div>
      <Container><Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button></Container>
    </div>
    
    </div>
  )
}
